import { RaRecord, Identifier } from 'react-admin'

export type ThemeName = 'light' | 'dark' | 'proudNerds'

export type TProductType = 'SimpleProduct' | 'ConfigurableProduct' | 'ConfigurationProduct'

export enum InputVariant {
    OUTLINED = 'outlined'
}

export interface PackageProduct extends RaRecord {
    active: boolean
    created_at: string
    definition: string
    id: Identifier
    package_id: Identifier
    pricing: string
    sku: string
    updated_at: string
}
export interface ChoiceType {
    id: string
    name: string
    type?: string
}
